
const personalityParameters = {
	SadnessJoy: [ 'Sadness', 'Joy' ],
	AngerFear: [ 'Anger', 'Fear' ],
	DisgustTrust: [ 'Disgust', 'Trust' ],
	NegativePositive: [ 'Negative', 'Positive' ],
	AggressivePeaceful: [ 'Aggressive', 'Peaceful' ],
	CautiousOpen: [ 'Cautious', 'Open' ],
	IntrovertExtravert: [ 'Introvert', 'Extrovert' ],
	InsecureConfident: [ 'Insecure', 'Confident' ]
};

const dialogStyles = [
	'Bubbly',
	'Formal',
	'Blunt',
	'Inquisitive',
	'Commanding',
	'Empathetic',
	'Entertaining',
	'Laid Back',
	'Long-winded',
	'Moral',
	'Mysterious',
	'Sarcastic',
	'Tenacious',
	'Villainous'
];

function calculatePrompt( persona ) {
	let prompt = [
		character( persona ),
		personality( persona ),
		dialogStyle( persona )
	];

	return prompt.join( "\n\n" );
}

function character( persona ) {
	return persona?.character_details ? `<CharacterDetails>${persona.character_details.trim()}</CharacterDetails>` : '';
}

function personality( persona ) {
	let out = '';

	for ( const key in personalityParameters ) {
		const [ min, max ] = personalityParameters[key];
		const cfg = persona?.personality_config;
		const level = cfg && key in cfg ? cfg[key] : 5;

		if ( level != 5 ) {
			out += `<Trait>${level} where ${min} is 1 and ${max} is 9</Trait>\n`;
		}
	}

	if ( out ) {
		out = '<PersonalityTrait>On a scale of 1 to 9, your personality traits are as follows: \n' + out + '</PersonalityTrait>';
	}

	return out;
}

function dialogStyle( persona ) {
	let dialog = 'Your dialog style is ';
	let last_dialog = null;

	const style = Array.isArray( persona?.dialog_style ) && persona.dialog_style.slice();

	if ( !style || style.length === 0 ) {
		return '';
	}

	if ( style.length > 1 ) {
		last_dialog = style.pop();
	}

	dialog += style.join( ', ' );
	if ( last_dialog ) {
		dialog += ', and ' + last_dialog;
	}

	dialog += '.';
	
	return dialog;
}


module.exports = {
	personalityParameters,
	dialogStyles,
	dialogStyle,
	calculatePrompt
};